// message bar
$('#messageBar').on('click tap', function() {
  const target = $(this).data('target');
  target ? window.location.href = target : null;
});

// accordions
$('.accordion > .card > .card--title').on('click tap', (e) => {
  $(e.target).closest('.card').toggleClass('open');
});

// collections slider
$('.collectionSlider--icon').on('click tap', function(e) {
  e.preventDefault();
  let target = $(this).data('collection');
  $(this).parent().parent().parent().find('.collectionSlider--products').hide();
  $(target).show();

  // reset slider-h scroll position
  $(this).parent().parent().parent().find('.slider-h').each(function() {
    this.scrollLeft = 0;
  })
  // console.log('%',target)
});

// blog search
$('#blogSearch').submit(function(e) {
  e.preventDefault();
  const host = (window.location.hostname === '127.0.0.1') ? 'http://127.0.0.1:9292' : `https://${window.location.hostname}`;
  const formDataArray = $(this).serializeArray();
  let params;
  $.each(formDataArray, function(i, v) {
    params += `&${v.name}=${v.value}`;
  });
  window.location.href = `${host}/search?view=blog&q=${params}`;
});

// prettify JSON
$(function() {
  const data = $('#jsonPretty').text();
  if(data) {
    const dataJson = JSON.parse(data);
    const dataJsonStringifyPretty = JSON.stringify(dataJson, null, 2);
    $('#jsonPretty').text(dataJsonStringifyPretty);
  }
});

// slider indicator
$('.slider-wrapper .slider-h').each(function() {
  // console.log(this.id, this.scrollWidth);
  const indicator = $(this).parent().find('.indicator-bar .indicator');
  $(this).on('scroll', function() {
    let scrollPosition = $(this).scrollLeft();
    let scrollPercentage = (scrollPosition / (this.scrollWidth - this.clientWidth)) * 100;
    $(indicator).css('left', `${scrollPercentage}%`);
  });
});


// // slider indicator dragging
// let indicator = null;
// let indicatorTarget = null;
// let initialX = null;

// $('.indicator').mousedown(function(event) {
//   indicator = this;
//   indicatorTarget = $(indicator).parent().data('target');
//   initialX = event.clientX;
// });

// $(document).mousemove(function(event) {
//   if (indicator && indicatorTarget) {
//     let positionRange = $(indicator).parent().width();
//     let positionStart = parseInt($(indicator).css('left'));
//     let positionChange = initialX - event.clientX;
//     let positionEnd = positionStart + (positionChange / positionRange);
//     let positionEndFinal = positionEnd < 0 ? 0 : positionEnd > 100 ? 100 : positionEnd;
//     console.log('#', positionEndFinal)
//     $(indicator).css('left', positionEndFinal);
//     // let scrollPercent = currentX / indicatorBarSize;
//     // let scrollAmount = $(indicatorTarget).width() * scrollPercent;
//     // initialX = event.clientX;
//     // console.log(scrollPercent,scrollAmount);
//     // $(indicatorTarget).animate({ scrollLeft: '+=' + scrollAmount }, 0);
//   }
// });

// $(document).mouseup(function() {
//   indicator = null;
//   indicatorTarget = null;
//   initialX = null;
// });

// slider indicator arrows
let isScrolling = false;

$('.indicator-bar .arrow').on('click', function(e) {
  indicatorTarget = $(this).parent().data('target');
  let x = Math.floor($(indicatorTarget).width() / 282) * 282;
  let isForward = $(this).hasClass('arrow-right');
  let isBack = $(this).hasClass('arrow-left');
  let scrollAmount = isForward ? x : isBack ? x * (-1) : 0;
  moveCustomScroller(indicatorTarget,scrollAmount);
});

async function moveCustomScroller(t,x) {
  if (isScrolling) return false;
  isScrolling = true;
  try {
    let l = $(t).scrollLeft();
    let r = l + $(t).width();
    let w = $(t).prop('scrollWidth');
    if (l === 0 && x < 0) return false;
    if (r === w && x > 0) return false;
    await new Promise(resolve => {
      $(t).animate({ scrollLeft: '+=' + x }, 500, resolve);
    });
  } finally {
    isScrolling = false;
  }
}



// account login functions & listeners
$('#RecoverPassword').on('click tap', function() {
  $('#RecoverPasswordForm').show();
  $('#CustomerLoginForm').hide();
});

$('#HideRecoverPasswordLink').on('click tap', function() {
  $('#RecoverPasswordForm').hide();
  $('#CustomerLoginForm').show();
});


// MODAL DIALOGS ---------------------------------------------------------------------------------------------------------- //

  // open modal & close modal
  $('.modalOpener').on('click tap', function() {
    let modalId = $(this).data('target');
    let modal = document.getElementById(modalId);
    document.body.classList.add('modal-open');
    console.log('!')
    modal.showModal();
  });

  // close modal with closer
  $('.modalCloser').on('click tap', function() {
    let modal = this.closest('dialog');
    document.body.classList.remove('modal-open');
    modal.close();
  });
  

// ADOPTION MODAL THUMBNAILS ---------------------------------------------------------------------------------------------- //

  // swap hero image
  $('.adoption-modal--media .thumb').on('click tap', function() {
    const src = $(this).attr('src');
    const hero = $(this).siblings('.hero');
    $(hero[0]).attr('src',src);
  });